export default class Header {
  constructor() {
    this.openNavClass = "nav--open";
    this.toggleMenu();
    this.hideMenu();
  }

  toggleMenu() {
    document.querySelector(".page-header__toggler").addEventListener("click", () => {
      document.querySelector("body").classList.toggle(this.openNavClass);
    });
  }

  hideMenu() {
    document.body.onkeydown = (e) => {
      if (e.key === "Escape" && document.querySelector("body").classList.contains(this.openNavClass)) {
        document.querySelector("body").classList.remove(this.openNavClass);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/header.js